import { FieldValue, increment } from 'firebase/firestore';
import { uniq } from 'lodash';
import uniqid from 'uniqid';
import { SemiProduct, Store, StoreLog, Worker } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  cafeSlug: string;
  semiProduct: DbDocument<SemiProduct>;
  quantity: number;
  storeId: string;
  worker: DbDocument<Worker>;
};

export const makeSemiProduct = async ({ semiProduct, quantity, cafeSlug, storeId, worker }: Props) => {
  const batch = createBatch();
  const storesToUpdate = uniq(semiProduct.components.map((c) => c.store));

  storesToUpdate.forEach((s) => {
    if (s) {
      const diff: Record<string, number> = {};
      const updates: Record<`residues.${string}`, FieldValue> = {};

      semiProduct.components.forEach((c) => {
        if (c.store === s) {
          const qnt = Math.round((c.qnt / (semiProduct.batchVolume || 1)) * quantity);
          updates[`residues.${c.id}`] = increment(-qnt);
          diff[c.id] = -qnt;
        }
      });

      batch.update<Store>(`cafes/${cafeSlug}/stores/${s}`, updates);

      batch.set<StoreLog>(`cafes/${cafeSlug}/storeLogs/${uniqid()}`, {
        time: new Date().getTime(),
        workerId: worker.id,
        workerName: worker.name,
        storeId: s,
        type: 'makeSemiProduct',
        diff,
        info: {
          type: 'makeSemiProduct',
          name: semiProduct.name,
          id: semiProduct.id,
        },
      });
    }
  });

  batch.update<Store>(`cafes/${cafeSlug}/stores/${storeId}`, {
    [`residues.${semiProduct.id}`]: increment(quantity),
  });

  batch.set<StoreLog>(`cafes/${cafeSlug}/storeLogs/${uniqid()}`, {
    time: new Date().getTime(),
    workerId: worker.id,
    workerName: worker.name,
    storeId,
    type: 'makeSemiProduct',
    diff: { [semiProduct.id]: quantity },
    info: {
      type: 'makeSemiProduct',
      name: semiProduct.name,
      id: semiProduct.id,
    },
  });

  await batch.commit();
};
